export default {
  title: 'Oeps!',
  text: 'Je hebt het maximumaantal familieleden toegevoegd.',
  button: 'Oké'
};
